import { GenericErrorBoundary } from 'components/common-form/builder/form/GenericErrorBoundary';
import { BookingPendingComponent } from 'components/common-form/sidePanel/status/booking.pending/booking.pending';
import { StreamExpiredComponent } from 'components/common-form/sidePanel/status/stream/streamExpired/StreamExpired';
import { StreamingStatusComponent } from 'components/common-form/sidePanel/status/stream/streaming/StreamingStatus';
import { StreamingTradeDoneComponent } from 'components/common-form/sidePanel/status/stream/tradeDone/StreamingTradeDone';
import type { WorkFlowStatus } from 'state/selectors';

import { ShareButton } from '../docToolbar/summary';
import { ErrorComponent } from './error/Error.status';
import { InitializedComponent } from './initialized/Initialized.status';
import { QuotedIndicativeComponent } from './quoted.indicative/Quoted.Indicative.status';
import { QuotedNonTradable } from './quoted.nonTradable/Quoted.NonTradable.status';
import { QuotedPreviously } from './quoted.previously/Quoted.Previously.status';
import { QuotedTradable } from './quoted.tradable/Quoted.Tradable.status';
import { QuoteRejected } from './quoteRejected/QuoteRejected';
import { QuotingComponent } from './quoting/Quoting.status';
import { ReadyComponent } from './ready/Ready.status';
import type { StatusProps } from './Status.connect';
import { connectStatus } from './Status.connect';
import { TradeDoneComponent } from './trade.done/trade.done';
import { TradePendingComponent } from './trade.pending/trade.pending';

function componentForStatus(status: WorkFlowStatus) {
  switch (status) {
    case 'INITIALIZED':
      return InitializedComponent;

    case 'QUOTING':
    case 'STREAMING_INITIATED':
      return QuotingComponent;
    case 'STREAM_EXPIRED':
      return StreamExpiredComponent;
    case 'STREAMING':
    case 'STREAMING_TRADABLE':
      return StreamingStatusComponent;

    case 'ERROR':
      return ErrorComponent;

    case 'QUOTED':
      return QuotedIndicativeComponent;

    case 'QUOTED_TRADABLE':
      return QuotedTradable;

    case 'QUOTED_PREVIOUSLY':
      return QuotedPreviously;

    case 'REJECTED':
      return QuoteRejected;

    case 'TRADE_AUTH_REJECTED':
      return QuotedNonTradable;

    case 'READY':
      return ReadyComponent;

    case 'TRADING':
      return TradePendingComponent;

    case 'BOOKING':
      return BookingPendingComponent;

    case 'STREAMING_TRADED':
      return StreamingTradeDoneComponent;
    case 'TRADED':
    case 'BOOKED':
      return TradeDoneComponent;

    case 'UNDEFINED':
      return null;

    default:
      throw new Error(`status is not supported ${status}`);
  }
}

export function StatusComponent({ tabId, status, color, workspaceType, isForBooking }: StatusProps) {
  const Comp = componentForStatus(status);

  return (
    Comp !== null && (
      <GenericErrorBoundary key={tabId}>
        <div id="side-panel-status" data-e2e="side-panel-status">
          <Comp tabId={tabId} workspaceType={workspaceType} isForBooking={isForBooking}>
            {color !== undefined && <ShareButton tabId={tabId} color={color} />}
          </Comp>
        </div>
      </GenericErrorBoundary>
    )
  );
}

export const Status = connectStatus(StatusComponent);

StatusComponent.displayName = 'SidePanelStatus';
